import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { FaEnvelope, FaMapMarkerAlt, FaGithub, FaLinkedin, FaPaperPlane, FaCheck } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import { commonData, content } from "../data";
import "./contact.css";

function Contact({ lang }) {
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  
  const t = content[lang].sections;
  const { personal } = commonData;

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    const serviceId = import.meta.env.VITE_EMAILJS_SERVICE_ID || import.meta.env.REACT_APP_EMAILJS_SERVICE_ID || (typeof process !== "undefined" ? process.env?.REACT_APP_EMAILJS_SERVICE_ID : "");
    const templateId = import.meta.env.VITE_EMAILJS_TEMPLATE_ID || import.meta.env.REACT_APP_EMAILJS_TEMPLATE_ID || (typeof process !== "undefined" ? process.env?.REACT_APP_EMAILJS_TEMPLATE_ID : "");
    const publicKey = import.meta.env.VITE_EMAILJS_PUBLIC_KEY || import.meta.env.REACT_APP_EMAILJS_PUBLIC_KEY || (typeof process !== "undefined" ? process.env?.REACT_APP_EMAILJS_PUBLIC_KEY : "");

    if (!serviceId || !templateId || !publicKey) {
      console.error("EmailJS API anahtarları eksik! .env dosyasında VITE_EMAILJS_SERVICE_ID, VITE_EMAILJS_TEMPLATE_ID ve VITE_EMAILJS_PUBLIC_KEY tanımlanmalı.");
      alert(lang === 'tr' 
        ? "E-posta servisi henüz yapılandırılmamış (API anahtarları eksik)." 
        : "Email service is not configured yet (missing API keys)."
      );
      setLoading(false);
      return;
    }

    emailjs
      .sendForm(serviceId, templateId, form.current, publicKey)
      .then(
        (result) => {
          setLoading(false);
          setSuccess(true);
          e.target.reset();
          setTimeout(() => setSuccess(false), 5000);
        },
        (error) => {
          console.error("EmailJS Hatası:", error);
          setLoading(false);
          alert(lang === 'tr' ? "Mesaj gönderilirken bir hata oluştu." : "An error occurred while sending the message.");
        }
      );
  };

  return (
    <div className="contact-container container">

      <motion.div
        className="contact-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h1 className="section-title">{t.contact_title}</h1>
        <p className="contact-subtitle">
          {t.contact_subtitle}
        </p>
      </motion.div>

      <div className="contact-content">

        <motion.div
          className="contact-info-card"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h3>{lang === 'tr' ? 'İletişim Bilgileri' : 'Contact Info'}</h3>

          <div className="info-item">
            <div className="icon-box">
              <FaEnvelope />
            </div>
            <div>
              <h4>Email</h4>
              <p><a href={`mailto:${personal.email}`}>{personal.email}</a></p>
            </div>
          </div>



          <div className="info-item">
            <div className="icon-box">
              <FaMapMarkerAlt />
            </div>
            <div>
              <h4>{lang === 'tr' ? 'Konum' : 'Location'}</h4>
              <p>{personal.location}</p>
            </div>
          </div>

          <div className="social-links-area">
            <h4>{lang === 'tr' ? 'Sosyal Medya' : 'Social Media'}</h4>
            <div className="social-buttons">
              <a href={personal.linkedin} target="_blank" rel="noreferrer" className="social-btn">
                <FaLinkedin />
              </a>
              <a href={personal.github} target="_blank" rel="noreferrer" className="social-btn">
                <FaGithub />
              </a>
            </div>
          </div>
        </motion.div>

        <motion.div
          className="contact-form-wrapper"
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <form ref={form} className="contact-form" onSubmit={sendEmail}>
            <div className="form-group">
              <label>{t.contact_form_name}</label>
              <input type="text" name="user_name" placeholder={lang === 'tr' ? 'Adınız' : 'Your Name'} className="form-input" required />
            </div>

            <div className="form-group">
              <label>{t.contact_form_email}</label>
              <input type="email" name="user_email" placeholder="ornek@email.com" className="form-input" required />
            </div>

            <div className="form-group">
              <label>{t.contact_form_msg}</label>
              <textarea name="message" placeholder="..." rows="5" className="form-input" required></textarea>
            </div>

            <button type="submit" className="btn btn-primary form-btn" disabled={loading}>
              {loading ? t.contact_sending : success ? (
                <>
                  <FaCheck /> {t.contact_sent}
                </>
              ) : (
                <>
                  <FaPaperPlane /> {t.contact_btn}
                </>
              )}
            </button>
          </form>
        </motion.div>

      </div>
    </div>
  );
}

export default Contact;